var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.364 12.707C20.5514 12.5195 20.6567 12.2652 20.6567 12C20.6567 11.7348 20.5514 11.4805 20.364 11.293L14.707 5.63601C14.6147 5.5405 14.5044 5.46431 14.3824 5.41191C14.2604 5.3595 14.1291 5.33191 13.9964 5.33076C13.8636 5.3296 13.7319 5.3549 13.609 5.40519C13.4861 5.45547 13.3744 5.52972 13.2806 5.62361C13.1867 5.7175 13.1124 5.82916 13.0621 5.95205C13.0118 6.07495 12.9865 6.20663 12.9877 6.33941C12.9889 6.47219 13.0164 6.60341 13.0688 6.72541C13.1213 6.84742 13.1974 6.95776 13.293 7.05001L17.243 11L3.99995 11C3.73474 11 3.48038 11.1054 3.29284 11.2929C3.10531 11.4804 2.99995 11.7348 2.99995 12C2.99995 12.2652 3.10531 12.5196 3.29284 12.7071C3.48038 12.8947 3.73474 13 3.99995 13L17.243 13L13.293 16.95C13.1108 17.1386 13.01 17.3912 13.0123 17.6534C13.0146 17.9156 13.1197 18.1664 13.3051 18.3518C13.4905 18.5372 13.7414 18.6424 14.0036 18.6447C14.2657 18.647 14.5183 18.5462 14.707 18.364L20.364 12.707Z",
    fill: "#004E77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.4122e6eb2061db2aa81e85c2e49ea463.svg";
export { ForwardRef as ReactComponent };